import React from 'react';

import Navigation from '@vfgroup-oneplatform/foundation/Utils/Navigation';
import { trimEnd as _trimEnd } from 'lodash';
import PropTypes from 'prop-types';

export default function withValidation(WrappedComponent) {
  return class extends React.Component {
    static propTypes = {
      navigation: PropTypes.object.isRequired,
    };

    state = {
      isValidPhone: null,
      isValidEmail: null,
    };

    componentWillUnmount() {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
    }

    timeOut = null;
    validate(
      validatePhone,
      validateEmail,
      withEmailOrPhoneValidation,
      charCountToStartValidation,
      text,
    ) {
      if (this.timeOut) {
        clearTimeout(this.timeOut);
      }
      let isValidPhone, isValidEmail;

      if (withEmailOrPhoneValidation) {
        if (text.length >= charCountToStartValidation) {
          this.timeOut = setTimeout(() => {
            if (validatePhone(_trimEnd(text))) {
              isValidPhone = 1;
            } else {
              isValidPhone = 0;
            }

            if (validateEmail(_trimEnd(text))) {
              isValidEmail = 1;
            } else {
              isValidEmail = 0;
            }

            if (
              isValidPhone !== this.state.isValidPhone ||
              isValidEmail !== this.state.isValidEmail
            ) {
              this.setState({ isValidPhone, isValidEmail });
            }
          }, 800);
        }
      } else {
        isValidPhone = 1;
        isValidEmail = 1;
        this.setState({ isValidPhone, isValidEmail });
      }
    }
    handleValidation = text => {
      const validatePhone = Navigation.instance.getParam(this, 'validatePhone', () => null);
      const validateEmail = Navigation.instance.getParam(this, 'validateEmail', () => null);

      const withEmailOrPhoneValidation = Navigation.instance.getParam(
        this,
        'withEmailOrPhoneValidation',
        true,
      );

      const charCountToStartValidation = Navigation.instance.getParam(
        this,
        'charCountToStartValidation',
        5,
      );

      this.setState(
        {
          isValidPhone: null,
          isValidEmail: null,
        },
        () =>
          this.validate(
            validatePhone,
            validateEmail,
            withEmailOrPhoneValidation,
            charCountToStartValidation,
            text,
          ),
      );
    };

    render() {
      const { isValidEmail, isValidPhone } = this.state;
      return (
        <WrappedComponent
          isValidPhone={isValidPhone}
          isValidEmail={isValidEmail}
          handleValidation={this.handleValidation}
          {...this.props}
        />
      );
    }
  };
}
